const meta = {
  release: 184
}

export default meta